import { create } from 'zustand'
import { User, CreateUserDto, UpdateUserDto } from '@/types'
import { usersService } from '@/services/users.service'

interface ResellersState {
  resellers: User[] | null
  isInitialized: boolean
  fetchResellers: (force?: boolean) => Promise<void>
  addReseller: (user: CreateUserDto) => Promise<User>
  updateReseller: (id: string, user: UpdateUserDto) => Promise<User>
  deleteReseller: (id: string) => Promise<void>
}

export const useResellersStore = create<ResellersState>((set, get) => ({
  resellers: null,
  isInitialized: false,

  fetchResellers: async (force = false) => {
    if (get().isInitialized && !force) return
    const data = await usersService.getResellers()
    set({ resellers: data, isInitialized: true })
  },

  addReseller: async (userData: CreateUserDto) => {
    const newUser = await usersService.create({ ...userData, role: userData.role })
    set(state => ({ resellers: [...(state.resellers || []), newUser] }))
    return newUser
  },

  updateReseller: async (id: string, userData: UpdateUserDto) => {
    const updatedUser = await usersService.update(id, userData)
    set(state => ({
      resellers: state.resellers?.map(u => (u._id === id ? updatedUser : u)),
    }))
    return updatedUser
  },

  deleteReseller: async (id: string) => {
    await usersService.delete(id)
    set(state => ({
      resellers: state.resellers?.filter(u => u._id !== id),
    }))
  },
}))
